<template>
    <div>
        <div>
            <Price v-if="pricing.type === 'amount'" :value="pricing.value" />
            <div v-else>
                <span>{{ pricing.value }}%</span>
            </div>
        </div>
        <div v-if="pricing.invoicing_type" class="font-size-sm font-weight-lighter">
            {{ __('subscriptions.invoicing.types.' + pricing.invoicing_type) }}
        </div>
        <div class="font-size-sm font-weight-lighter">
            {{ __('subscriptions.invoicing.periods.' + pricing.invoicing_period) }}
        </div>
    </div>
</template>

<script>
import Price from "../../Price.vue";

export default {
    components: {Price},

    props: {
        pricing: Object
    }
}
</script>
